export enum CustomErrorTitle {
  EMPTY = '',
  OOPS_SOMETHING_WENT_WRONG = 'Ops... algo deu errado!',
  WARNING = 'Atenção!',
  UNABLE_TO_LOGIN = 'Não foi possível realizar o login!',
  SUCCESS = 'Sucesso!',
}
